import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const NavBar = () => {
    return (
        <div sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" color="primary">
            <Toolbar>
                <Typography sx={{ flexGrow: 1 }}>
                    <img src="/grip-logo-white.png" alt="Grip Security Azure Plan" height="30" />
                </Typography>
            </Toolbar>
            </AppBar>
        </div>
    );
};

export default NavBar;